export default __webpack_public_path__ + "static/media/maxim1.a95a5896.jpg";